import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import MainLayout from "../../../layouts/main/main_layout";
import { ArrowBackRounded, Download, QuizRounded } from "@mui/icons-material";
import Loading from "../../../components/loading/loading";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import XlsIcon from "../../../assets/xls_icon.svg";
import {
  downloadChoice,
  getChoiceUserDetails,
} from "../../../services/choices/choices_services";
import { useQuery } from "react-query";
import { downloadFromBlob } from "../../../utils/utils";
import { ResponseDetails } from "../model/response_details";
import "survey-react/survey.css";
import SurveyMedia from "../../../components/survey_media/survey_media";
import { black, greenLight, greyEnabled, purple, purpleLight } from "../../../theme/colors";

export default function ResponseDetailPage() {
  const [currentTab, setCurrentTab] = React.useState(0);
  const [downloading, setDownloading] = useState(false);
  let { id } = useParams();
  let { state } = useLocation();
  const { data: responseData, isLoading } = useQuery<ResponseDetails>(
    ["viewResponseDetails", id, state?.id],
    async () => {
      let response = await getChoiceUserDetails(+id!, +state.id!);
      return response.data.data || [];
    }
  );

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
  };

  const downloadViewChoiceApiCall = () => {
    setDownloading(true);
    downloadChoice({
      choiceAnswersId: +id!,
      format: "excel",
      choiceId: +state?.id!,
    })
      .then((res) => {
        let extension = ".xlsx";
        downloadFromBlob(res, extension);
      })
      .catch((e) => { })
      .finally(() => setDownloading(false));
  };

  const navigate = useNavigate();

  const renderCompoBasedOnTheTab = () => {
    switch (currentTab) {
      case 0:
        return personalDetails();
      case 1:
        return locationDetails();
      case 2:
        return otherDetails();
      case 3:
        return durableDetails();
    }
  };

  function answerType({ type, response }: { type: string; response: any }) {
    switch (type) {
      case null:
        return (
          (typeof response === "string" || typeof response === "boolean") && (
            <Box>
              <Typography>{response?.toString()}</Typography>
            </Box>
          )
        );
      case "text":
      case "comment":
      case "radiogroup":
      case "rating":
      case "checkbox":
      case "dropdown":
      case "tagbox":
      case "ranking":
      case "boolean":
        return (
          <Box>
            <Typography>{response?.toString()}</Typography>
          </Box>
        );
      case "multipletext":
        const objectValuesArray = Object.values(response);
        return (
          <Box>
            {objectValuesArray.map((value: any, index: any) => (
              <Typography>{value}</Typography>
            ))}
          </Box>
        );
      case "matrix":
        return (
          <Box>
            {Object.keys(response).map((qsn) => {
              return (
                <Typography>{`${qsn} : ${response[`${qsn}`]}`}</Typography>
              );
            })}
            <Typography></Typography>
          </Box>
        );
      case "matrixdropdown":
        return (
          <Box>
            {Object.keys(response).map((qsn) => {
              return (
                <Box display={"flex"}>
                  <Typography>{`${qsn} : `}</Typography>
                  {Object.keys(response[qsn]).map((item) => (
                    <Typography mx={1}>
                      {` ${item} -> ${response[qsn][item]}`}
                    </Typography>
                  ))}
                </Box>
              );
            })}
            <Typography></Typography>
          </Box>
        );
      case "matrixdynamic":
        return (
          <Box>
            {response.map((item: any) => {
              return Object.keys(item).map((qsnKey: any) => {
                return (
                  <Typography>{`${qsnKey} : ${item[`${qsnKey}`]}`}</Typography>
                );
              });
            })}
            <Typography></Typography>
          </Box>
        );
      case "file":
        return (
          <Box>
            {response.map((item: any) => {
              // Backend returns { url, name, mimeType, fileType } (a signed
              // GCS URL), not { content, type }.
              const mediaType =
                item.mimeType || (item.fileType === "gif" ? "image/gif" : item.fileType);
              return (
                <Box py={1}>
                  <Box display="flex" alignItems="center">
                    <Typography variant="body2">{item.name}</Typography>
                    &nbsp;&nbsp;{" "}
                    <a href={item.url} download={item.name} style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
                      <IconButton size="small">
                        <Download />
                      </IconButton>
                    </a>
                  </Box>

                  {item.url && item.fileType !== "file" && (
                    <SurveyMedia url={item.url} type={mediaType} />
                  )}
                </Box>
              );
            })}
            <Typography></Typography>
          </Box>
        );
    }
  }

  function personalDetails() {
    return (
      <>
        {/* <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "UID",
            value: responseData?.user?.id,
          })}
        </Grid> */}
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Full Name",
            value: responseData?.userDetails?.name,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Date of Birth",
            value: new Date(responseData?.userDetails?.dob || '').toLocaleDateString('en-GB'),
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Gender",
            value: responseData?.userDetails?.gender,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Marital Status  (Optional)",
            value: responseData?.userDetails?.maritalStatus,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Email  (Optional)",
            value: responseData?.userDetails?.email,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Mobile Numer",
            value: responseData?.userDetails?.mobileNumber,
          })}
        </Grid>
        {/* <Grid item md={6} lg={6} sm={12} xs={12}></Grid> */}
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Family Income",
            value: responseData?.userDetails?.familyIncome,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Subscribed to Newsletter",
            value: "",
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Newsletter Email ID",
            value: "",
          })}
        </Grid>
      </>
    );
  }
  function locationDetails() {
    return (
      <>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "House/Flat/Room No. (Optional)",
            value: responseData?.locationDetails?.addressLine1,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Building/Chawl Name/No. (Optional)",
            value: responseData?.locationDetails?.addressLine2,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Street/Road No./Name (Optional)",
            value: responseData?.locationDetails?.addressLine3,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Locality/Area",
            value: responseData?.locationDetails?.area,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Landmark (Optional)",
            value: responseData?.locationDetails?.landmark,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "State",
            value: responseData?.locationDetails?.state,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "District",
            value: responseData?.locationDetails?.district,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "PIN Code",
            value: responseData?.locationDetails?.pincode,
          })}
        </Grid>
      </>
    );
  }

  function otherDetails() {
    return (
      <>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Educational Qualification",
            value: responseData?.otherDetails?.education,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Working Status",
            value: responseData?.otherDetails?.workingStatus,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Occupation",
            value: responseData?.otherDetails?.occupation,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Family Type",
            value: responseData?.otherDetails?.familtyType,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Ownership of House",
            value: responseData?.otherDetails?.houseOwnership,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Personal Income",
            value: responseData?.otherDetails?.personalIncome,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}>
          {listItem({
            title: "Family Income",
            value: responseData?.otherDetails?.familyIncome,
          })}
        </Grid>
        <Grid item md={6} lg={6} sm={12} xs={12}></Grid>
      </>
    );
  }

  function durableDetails() {
    return (
      <Grid item md={6} lg={6} sm={12} xs={12}>
        <Typography color="primary.main">{"Durable details"}</Typography>
        {responseData?.durableDetails?.length === 0 ? (
          <Typography>-</Typography>
        ) : (
          responseData?.durableDetails?.map((durableItems) => {
            return <Typography>{durableItems}</Typography>;
          })
        )}
      </Grid>
    );
  }

  function listItem({
    title,
    value,
  }: {
    title: string;
    value: any;
  }): JSX.Element {
    return (
      <Box style={{ overflow: "hidden" }}>
        <Typography variant="body2" sx={{ color: black, fontWeight: 600, letterSpacing: 0.2 }}>
          {title}
        </Typography>
        <Typography sx={{ color: black, fontWeight: 500, mt: 0.25 }} textOverflow="ellipsis" overflow="hidden">
          {value || "-"}
        </Typography>
      </Box>
    );
  }

  function divider() {
    return (
      <Divider
        sx={{
          display: "flex",
          opacity: 0.6,
          borderBottom: "1px dotted #ABA0AB",
        }}
      />
    );
  }

  return (
    <MainLayout>
      <Grid container mt={4}>
        <Grid item lg={8} md={12} sm={12} xs={12} xl={8}>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  bgcolor: purpleLight,
                  flexShrink: 0,
                }}
              >
                <QuizRounded sx={{ color: purple, fontSize: 22 }} />
              </Box>
              <Box>
                <Typography variant="h5" fontWeight={700} color={black}>
                  Survey Response Details
                </Typography>
                <Typography variant="body2" color={greyEnabled}>
                  {responseData?.userDetails?.name || "View survey response submission details."}
                </Typography>
              </Box>
            </Box>
          </Box>

          {isLoading ? (
            <Card
              elevation={0}
              sx={{
                display: "flex",
                minHeight: 500,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 3,
                border: "1px solid #ECECEC",
              }}
            >
              <Box display="flex" justifyContent="center" py={8}>
                <Loading />
              </Box>
            </Card>
          ) : (
            <Card elevation={0} sx={{ borderRadius: 3, border: "1px solid #ECECEC" }}>
              <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
                <Tabs
                  value={currentTab}
                  onChange={handleChange}
                  sx={{ borderBottom: `1px solid ${purpleLight}` }}
                >
                  <Tab
                    label="Personal details"
                    sx={{ textTransform: "capitalize", color: black, fontWeight: 600 }}
                  />
                  <Tab
                    label="Location details"
                    sx={{ textTransform: "capitalize", color: black, fontWeight: 600 }}
                  />
                  <Tab
                    label="Other details"
                    sx={{ textTransform: "capitalize", color: black, fontWeight: 600 }}
                  />
                  <Tab
                    label="Durable details"
                    sx={{ textTransform: "capitalize", color: black, fontWeight: 600 }}
                  />
                </Tabs>
                <Box>
                  <Grid container spacing={3} mt={0.5}>
                    {renderCompoBasedOnTheTab()}
                  </Grid>
                </Box>

                <Box mt={3}>{divider()}</Box>
                <Box mt={2}>
                  <Typography variant="subtitle1" fontWeight={700} color={black}>
                    Question and Answers
                  </Typography>
                </Box>
                <Box mt={1}>
                  <Card
                    elevation={0}
                    sx={{
                      height: 350,
                      overflowY: "scroll",
                      p: 2,
                      borderRadius: 3,
                      border: "1px solid #ECECEC",

                      "&::-webkit-scrollbar": {
                        width: "8px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#F5E6F5",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#DFB0DF",
                        borderRadius: "6px",
                      },
                    }}
                  >
                    {responseData?.choiceDetails?.answerList?.map(
                      (
                        items: {
                          question: string;
                          questionType: string;
                          response: any;
                        },
                        index: any
                      ) => {
                        return (
                          items.response && (
                            <Box mb={1}>
                              <Typography color={purple} variant="body2" fontWeight={600}>
                                {index + 1}. {items?.question}
                              </Typography>
                              {answerType({
                                type: items.questionType,
                                response: items.response,
                              })}
                            </Box>
                          )
                        );
                      }
                    )}
                  </Card>
                </Box>

                <Box mt={4}>{divider()}</Box>

                <Box
                  display="flex"
                  flexDirection="row"
                  flexWrap="wrap"
                  mt={3}
                  gap={1.5}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Button
                    onClick={() => navigate(-1)}
                    variant="outlined"
                    startIcon={<ArrowBackRounded sx={{ height: 18, width: 18 }} />}
                    sx={{
                      borderColor: purple,
                      color: purple,
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                      "&:hover": { borderColor: purple, bgcolor: purpleLight },
                    }}
                  >
                    Back To Responses
                  </Button>
                  <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography variant="subtitle2" fontWeight={600}>
                      Generate Report:
                    </Typography>
                    <Tooltip title="Download as XLS">
                      <span>
                        <IconButton
                          disabled={downloading}
                          onClick={downloadViewChoiceApiCall}
                          sx={{ bgcolor: greenLight, borderRadius: 2, ml: 1.5, height: 36, width: 36 }}
                        >
                          {downloading ? (
                            <CircularProgress size={18} sx={{ color: purple }} />
                          ) : (
                            <img src={XlsIcon} alt="" style={{ height: 20, width: 20 }} />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          )}
        </Grid>
      </Grid>
    </MainLayout>
  );
}
